import { render, staticRenderFns } from "./NewProjectFeed.vue?vue&type=template&id=43970e70&scoped=true&"
import script from "./NewProjectFeed.vue?vue&type=script&lang=js&"
export * from "./NewProjectFeed.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectFeed.vue?vue&type=style&index=0&id=43970e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43970e70",
  null
  
)

export default component.exports